import { render, staticRenderFns } from "./InputJson.vue?vue&type=template&id=5071ad58&"
import script from "./InputJson.vue?vue&type=script&lang=js&"
export * from "./InputJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports